<template>
    <div class="cointainer">
    

        <!-- Modal component -->
        <b-modal id="agentMemberUpdateModal" :title="modals.memberRegistration" @ok="handleModalOkClick" @hidden="reset" size="lg" ok-title="更新" cancel-title="キャンセル" modal-class="agent-netenglish-modal">

            <div v-if="isSuccess == true" class="text-center">
                <div class="alert alert-success" role="alert">
                    {{ this.message }}
                </div>
            </div>

            <form @submit.prevent="submitForm" autocomplete="off">

                <!-- Email Address -->
                <b-form-group label-class="small" :label="labels.email" label-for="email"
                    :invalid-feedback="formErrors.email">
                    <b-form-input type="email" id="email" v-model="form.email" :state="formErrors.email ? false : null"
                        required size="sm" @input="validateField('email')"></b-form-input>
                </b-form-group>

                <b-row>
                    <!-- Japanese Last Name (姓) -->
                    <b-col md="6">
                        <b-form-group label-class="small" :label="labels.japaneseLastName" label-for="japaneseLastName"
                            :invalid-feedback="formErrors.japaneseLastName">
                            <b-form-input id="japaneseLastName" v-model="form.japaneseLastName"
                                :state="formErrors.japaneseLastName ? false : null" required size="sm"
                                @input="validateField('japaneseLastName')"></b-form-input>
                        </b-form-group>
                    </b-col>

                    <!-- Japanese First Name (名) -->
                    <b-col md="6">
                        <b-form-group label-class="small" :label="labels.japaneseFirstName" label-for="japaneseFirstName"
                            :invalid-feedback="formErrors.japaneseFirstName">
                            <b-form-input id="japaneseFirstName" v-model="form.japaneseFirstName"
                                :state="formErrors.japaneseFirstName ? false : null" required size="sm"
                                @input="validateField('japaneseFirstName')"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <!-- Last Name (姓・ローマ字) -->
                    <b-col md="6">
                        <b-form-group label-class="small" :label="labels.lastName" label-for="lastName"
                            :invalid-feedback="formErrors.lastName">
                            <b-form-input id="lastName" v-model="form.lastName"
                                :state="formErrors.lastName ? false : null" required size="sm"
                                @input="validateField('lastName')"></b-form-input>
                        </b-form-group>
                    </b-col>

                    <!-- First Name (名・ローマ字) -->
                    <b-col md="6">
                        <b-form-group label-class="small" :label="labels.firstName" label-for="firstName"
                            :invalid-feedback="formErrors.firstName">
                            <b-form-input id="firstName" v-model="form.firstName"
                                :state="formErrors.firstName ? false : null" required size="sm"
                                @input="validateField('firstName')"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <!-- Attribute (Trial, Member, Withdraw) (EXCLUDED)
                <b-row>
                    
                    <b-col md="6">
                        <b-form-group label-class="small" :label="labels.attribute" label-for="attribute"
                            :invalid-feedback="formErrors.attribute">
                            <b-form-select id="attribute" v-model="form.attribute"
                                :state="formErrors.attribute ? false : null" required size="sm"
                                @input="validateField('attribute')">
                                <b-form-select-option value="trial">Trial</b-form-select-option>
                                <b-form-select-option value="member">Member</b-form-select-option>
                                <b-form-select-option value="withdraw">Withdraw</b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                -->

                <!-- Nickname -->
                <b-form-group label-class="small" :label="labels.nickname" label-for="nickname" :invalid-feedback="formErrors.nickname">
                    <b-form-input id="nickname" v-model="form.nickname" :state="formErrors.nickname ? false : null"
                        required size="sm" @input="validateField('nickname')"></b-form-input>
                </b-form-group>

                <b-row>
                    <!-- Gender -->
                    <b-col md="6">

                        <b-form-group label-class="small">
                            <label class="small">{{ labels.gender }}</label>
                            <b-form-radio-group 
                                v-model="form.gender" 
                                :state="formErrors.gender ? false : null" 
                                required 
                                size="sm" 
                                @input="validateField('gender')"
                            >
                                <b-form-radio value="male" class="small">Male</b-form-radio>
                                <b-form-radio value="female" class="small">Female</b-form-radio>
                            </b-form-radio-group>
                            <b-form-invalid-feedback v-if="formErrors.gender">
                                {{ formErrors.gender }}
                            </b-form-invalid-feedback>
                        </b-form-group>                        

                    </b-col>
                </b-row>

                <b-alert show variant="info" class="small mb-3">
                    レッスンはマイページ内のブラウザレッスンルーム（WebRTC）で行います。Zoom / Teams の登録は不要です。
                </b-alert>

                <div class="border border-duv rounded ">

                    <b-row class="mt-2">
                        <b-col md="12">
                            <span class="px-1 ">受講生パスワードの更新</span>
                        </b-col>
                    </b-row>

                    <b-row class="p-2">


                        <b-col md="6">
                            <!-- Password -->
                            <b-form-group label-class="small" :label="labels.newPassword" label-for="newPassword" :invalid-feedback="formErrors.newPassword">
                                <b-form-input type="password" id="newPassword" v-model="form.newPassword"
                                    :state="formErrors.newPassword ? false : null"  size="sm" autocomplete="new-password"
                                    @input="validatePasswordField('newPassword')"> </b-form-input>
                            </b-form-group>
                        </b-col>

                        <b-col md="6">
                            <!-- Confirm Password -->
                            <b-form-group label-class="small" :label="labels.confirmNewPassword" label-for="confirmNewPassword"
                                :invalid-feedback="formErrors.confirmNewPassword">
                                <b-form-input type="password" id="confirmNewPassword" v-model="form.confirmNewPassword" autocomplete="off"
                                    :state="formErrors.confirmNewPassword ? false : null"  size="sm"
                                    @input="validatePasswordField('confirmNewPassword')"
                                    ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                </div>

            </form>
        </b-modal>
    </div>
</template>


<script>
export default {
    props: {
        memberships: Array,
        csrf_token: String,
        api_token: String,
        agent_info: Object,
        agent_user_id: Number,
    },
    data() {
        return {
            modals: {
                memberRegistration: '受講生情報の更新'
            },
            member: null,
            isLoading: false,
            isSuccess: false,
            message: '',
            form: {
                email: '',
                japaneseLastName: '',
                japaneseFirstName: '',
                firstName: '',
                lastName: '',
                nickname: '',
                gender: '',
                communicationApp: '',
                communicationUsername: '',
                newPassword: '',
                confirmNewPassword: ''
            },
            formErrors: {
                email: null,
                japaneseLastName: null,
                japaneseFirstName: null,
                firstName: null,
                lastName: null,
                nickname: null,
                gender: null,
                communicationApp: null,
                communicationUsername: null,
                newPassword: null,
                confirmNewPassword: null
            },
  
            fieldNames: {
                email: 'メールアドレス',
                japaneseLastName: '姓',
                japaneseFirstName: '名',
                firstName: '名（ローマ字）',
                lastName: '姓（ローマ字）',
                nickname: 'ニックネーム（ローマ字）講師が呼びやすいネーム（例：ファ-ストネーム)',
                gender: '性別',
                communicationApp: '通信アプリ',
                communicationUsername: '通信アプリのID',
                newPassword: 'パスワード',
                confirmNewPassword: 'パスワードを認証する'
            },
            labels: {
                email: 'メールアドレス',
                japaneseLastName: '姓',
                japaneseFirstName: '名',
                firstName: '名（ローマ字）',
                lastName: '姓（ローマ字）',
                nickname: 'ニックネーム（ローマ字）講師が呼びやすいネーム（例：ファ-ストネーム)',
                gender: '性別',
                communicationApp: '通信アプリ',
                communicationUsername: '通信アプリのID',
                newPassword: 'パスワード',
                confirmNewPassword: 'パスワードを認証する'
            }
        };
    },
    mounted() {
        window.openAgentMemberUpdateModal = this.openAgentMemberUpdateModal;
    },
    methods: {
        reset() {
            this.isLoading = false;
            this.isSuccess = false;
            this.message = '';
            this.member = '';
            this.form = {
                email: '',
                japaneseLastName: '',
                japaneseFirstName: '',
                firstName: '',
                lastName: '',
                nickname: '',
                gender: '',
                communicationApp: '',
                communicationUsername: '',
                newPassword: '',
                confirmNewPassword: ''
            };
            this.formErrors = {
                email: null,
                japaneseLastName: null,
                japaneseFirstName: null,
                firstName: null,
                lastName: null,
                nickname: null,
                gender: null,
                communicationApp: null,
                communicationUsername: null,
                newPassword: null,
                confirmNewPassword: null
            };
          
        },
        validateForm() {
            let isValid = true;

            Object.keys(this.form).forEach(field => {
                // Skip password fields for now (we'll handle below)
                if (field === 'newPassword' || field === 'confirmNewPassword') return;
                if (field === 'communicationApp' || field === 'communicationUsername') return;

                if (!this.form[field] || this.form[field].trim() === '') {
                    this.$set(this.formErrors, field, `${this.fieldNames[field]} が必要です`);
                    isValid = false;
                } else {
                    this.$set(this.formErrors, field, null); // Clear any previous error
                }
            });

            // ✅ Password validation only if either field has a value
            if (this.form.newPassword.trim() !== '' || this.form.confirmNewPassword.trim() !== '') {
                if (this.form.newPassword.trim() === '') {
                    this.$set(this.formErrors, 'newPassword', `${this.fieldNames.newPassword} が必要です`);
                    isValid = false;
                }

                if (this.form.confirmNewPassword.trim() === '') {
                    this.$set(this.formErrors, 'confirmNewPassword', `${this.fieldNames.confirmNewPassword} が必要です`);
                    isValid = false;
                }

                if (
                    this.form.newPassword.trim() !== '' &&
                    this.form.confirmNewPassword.trim() !== '' &&
                    this.form.newPassword !== this.form.confirmNewPassword
                ) {
                    this.$set(this.formErrors, 'confirmNewPassword', 'パスワードが一致しません');
                    isValid = false;
                }
            }

            return isValid;
        },
        validateField(fieldName) {
            this.$set(this.formErrors, fieldName, null);

            if (!this.form[fieldName] || this.form[fieldName].trim() === '') {
                this.$set(this.formErrors, fieldName, `${this.fieldNames[fieldName]} が必要です`);
                return;
            }

            if (fieldName === 'email') {
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailPattern.test(this.form.email)) {
                    this.$set(this.formErrors, 'email', '有効なメールアドレスを入力してください');
                }
            }
        },
        validatePasswordField(fieldName) {
            this.$set(this.formErrors, fieldName, null);

            if (fieldName === 'newPassword' && this.form.newPassword.trim() !== '') {

                console.log(fieldName , "validate password field")

                if (this.form.newPassword !== this.form.confirmNewPassword) {
                    this.$set(this.formErrors, 'confirmNewPassword', 'パスワードが一致しません');
                } else {
                    this.$set(this.formErrors, 'confirmNewPassword', null); // ✅ Clear error if they match
                }
            }
        },        
        openAgentMemberUpdateModal(member) {


            this.member = member;

            console.log(member);

            let gender = member.gender.toLowerCase();

            this.form = {
                email: member.email,
                japaneseLastName: member.japanese_lastname,
                japaneseFirstName: member.japanese_firstname,
                firstName: member.firstname,
                lastName: member.lastname,
                nickname: member.nickname,
                gender: gender,
                communicationApp: 'webrtc',
                communicationUsername: '',
                newPassword: '',
                confirmNewPassword: ''
            };

            this.$bvModal.show('agentMemberUpdateModal');
            this.$forceUpdate();
        },
        closeAgentMemberUpdateModal() {
            this.$bvModal.hide('agentMemberUpdateModal');
            this.reset();
        },
        handleModalOkClick($event) {
            $event.preventDefault();
            this.submitForm();
        },
        submitForm() {
            if (this.validateForm()) {
                this.form.attribute = 'member';
                this.form.communicationApp = 'webrtc';
                this.form.communicationUsername = '';

                axios.post("/api/update_agent_member?api_token=" + this.api_token, {
                    method: "POST",
                    form: JSON.stringify(this.form),
                    agent_user_id: this.agent_user_id,
                    user_id: this.member.user_id
                }).then(response => {                   
                    if (response.data.success === false) {
                        alert(response.data.message);
                    } else {
                        this.isSuccess = true;
                        this.message = response.data.message;

                        this.$emit('update-member', response.data.userData); // custom event


                        setTimeout(() => {
                            this.closeAgentMemberUpdateModal();
                            this.reset();
                        }, 2500);


                    }
                }).catch(function (error) {
                    alert("Error " + error);
                });
            }
        }
    }
};
</script>


